<div class="contact_edit__container">
  <div class="contact_edit__fields bfx-section-wrapper">
    <span>
      <label for="client">Client</label>
      <bfx-text-input
        id="client"
        type="search"
        size="sm"
        [(ngModel)]="client.clientName"
        [maxLength]="256"
        [disabled]="true"
        (focus)="$event.target.select()"
      ></bfx-text-input>
    </span>
    <span>
      <label for="contact-name">Contact Name</label>
      <bfx-text-input
        id="contact-name"
        [ngClass]="{'valid': valid[1]==1, 'invalid': valid[1]==2}"
        (blur)="validate(1)"
        size="sm"
        type="search"
        [(ngModel)]="clientContact.contactNameTxt"
        [maxLength]="200"
        [disabled]="locked"
        (focus)="$event.target.select()"
      ></bfx-text-input>
    </span>
    <span>
      <label for="desk">Desk</label>
      <bfx-text-input
        id="desk"
        [ngClass]="{'valid': valid[2]==1, 'invalid': valid[2]==2}"
        (blur)="validate(2)"
        size="sm"
        type="search"
        [(ngModel)]="clientContact.deskTxt"
        [maxLength]="200"
        [disabled]="locked"
        (focus)="$event.target.select()"
      ></bfx-text-input>
    </span>
    <span>
      <label for="mobile">Mobile</label>
      <bfx-text-input
        id="mobile"
        [ngClass]="{'valid': valid[3]==1, 'invalid': valid[3]==2}"
        (blur)="validate(3)"
        size="sm"
        type="search"
        [(ngModel)]="clientContact.mobileTxt"
        [maxLength]="200"
        [disabled]="locked"
        (focus)="$event.target.select()"
      ></bfx-text-input>
    </span>
    <span>
      <label for="sms">SMS</label>
      <bfx-text-input
        id="sms"
        [ngClass]="{'valid': valid[4]==1, 'invalid': valid[4]==2}"
        (blur)="validate(4)"
        size="sm"
        type="search"
        [(ngModel)]="clientContact.smsTxt"
        [maxLength]="200"
        [disabled]="locked"
        (focus)="$event.target.select()"
      ></bfx-text-input>
    </span>
    <span>
      <label for="email">Email</label>
      <bfx-text-input
        id="email"
        [ngClass]="{'valid': valid[5]==1, 'invalid': valid[5]==2}"
        (blur)="validate(5)"
        type="search"
        size="sm"
        [(ngModel)]="clientContact.emailTxt"
        [maxLength]="3000"
        [disabled]="locked"
        (focus)="$event.target.select()"
      ></bfx-text-input>
    </span>
    <span class="checkbox-pane">
      <span>
        <p-checkbox
          [ngClass]="{'valid': notifyEntryEmail}"
          [binary]="true"
          [disabled]="locked || !emailValid()"
          class="bfx-checkbox-bold-sm"
          label="Entry Email"
          [(ngModel)]="notifyEntryEmail"
        ></p-checkbox>
        <p-checkbox
          [ngClass]="{'valid': notifyEntrySMS}"
          [binary]="true"
          [disabled]="locked || !smsValid()"
          class="bfx-checkbox-bold-sm"
          label="Entry SMS"
          [(ngModel)]="notifyEntrySMS"
        ></p-checkbox>
        <p-checkbox
          [ngClass]="{'valid': notifyModifyEmail}"
          [binary]="true"
          [disabled]="locked || !emailValid()"
          class="bfx-checkbox-bold-sm"
          label="Modify Email"
          [(ngModel)]="notifyModifyEmail"
        ></p-checkbox>
        <p-checkbox
          [ngClass]="{'valid': notifyModifySMS}"
          [binary]="true"
          class="bfx-checkbox-bold-sm"
          [disabled]="locked || !smsValid()"
          label="Modify SMS"
          [(ngModel)]="notifyModifySMS"
        ></p-checkbox>
        <p-checkbox
          [ngClass]="{'valid': notifyExpiryEmail}"
          [binary]="true"
          class="bfx-checkbox-bold-sm"
          [disabled]="locked || !emailValid()"
          label="Expiry Email"
          [(ngModel)]="notifyExpiryEmail"
        ></p-checkbox>
        <p-checkbox
          [ngClass]="{'valid': notifyExpirySMS}"
          [binary]="true"
          class="bfx-checkbox-bold-sm"
          [disabled]="locked || !smsValid()"
          label="Expiry SMS"
          [(ngModel)]="notifyExpirySMS"
        ></p-checkbox>
        <p-checkbox
          [ngClass]="{'valid': notifyFillEmail}"
          [binary]="true"
          class="bfx-checkbox-bold-sm"
          [disabled]="locked || !emailValid()"
          label="Fill Email"
          [(ngModel)]="notifyFillEmail"
        ></p-checkbox>
        <p-checkbox
          [ngClass]="{'valid': notifyFillSMS}"
          [binary]="true"
          class="bfx-checkbox-bold-sm"
          [disabled]="locked || !smsValid()"
          label="Fill SMS"
          [(ngModel)]="notifyFillSMS"
        ></p-checkbox>
        <p-checkbox
          [ngClass]="{'valid': notifyCancelEmail}"
          [binary]="true"
          class="bfx-checkbox-bold-sm"
          [disabled]="locked || !emailValid()"
          label="Cancel Email"
          [(ngModel)]="notifyCancelEmail"
        ></p-checkbox>
        <p-checkbox
          [ngClass]="{'valid': notifyCancelSMS}"
          [binary]="true"
          class="bfx-checkbox-bold-sm"
          [disabled]="locked || !smsValid()"
          label="Cancel SMS"
          [(ngModel)]="notifyCancelSMS"
        ></p-checkbox>
        <p-checkbox
          [ngClass]="{'valid': clientContact.isDefaultFg}"
          [binary]="true"
          [disabled]="locked"
          class="bfx-checkbox-bold-sm"
          label="Default Contact"
          [(ngModel)]="clientContact.isDefaultFg"
        ></p-checkbox>
      </span>
    </span>
    <span> </span>
  </div>
  <div class="divider"></div>
  <div class="btn-bar">
    <button class="bfx-button-negative" (click)="cancel()">Cancel</button>
    <button class="bfx-button-primary" [disabled]="!isSaveEnabled()" (click)="save()">Save</button>
  </div>
</div>
